/* eslint-disable no-console */
const parse = require("html-react-parser");

const CUSTOM_BLOCK_CLASSNAMES = {
  CHILD_PAGES: "child-pages",
  THUMBNAIL: "thumbnail-icon",
  PAGE_DESCRIPTION: "page-description",
  FAQ_PAGES: "faq-pages",
  CONTACT_SUPPORT: "contact-support",
  FEEDBACK_SURVEY: "feedback-survey",
  RELATED_QUERIES: "related-queries",
  CTA: "cta",
  VIDEO_TAG: "video-container",
  EMBED: "yt-embed",
};

const createPagesData = allPages => {
  const allPagesData = {};
  const categoryAndTagMap = {};
  const searchDataArrayObject = [];
  allPages.forEach(page => {
    const {
      uri = "",
      id = "",
      title = "",
      template: { templateName = "" } = {},
      databaseId,
      status,
      content,
      nodeType,
      categoryAndTag: { categoryAndTag = "" } = {},
      seo: {
        title: seoTitle = "",
        metaDesc: seoMetaDesc = "",
      } = {},
    } = page || {};
    const allCategoriesAndTags = categoryAndTag?.split(
      "\r\n"
    );
    allCategoriesAndTags?.forEach(tc => {
      if (tc) {
        categoryAndTagMap[tc] = uri;
      }
    });
    const parserObject = parserWrapper(content, uri);

    searchDataArrayObject.push({
      id,
      uri,
      title,
      description: content,
      searchKeywords: parserObject.searchKeywords,
    });

    allPagesData[uri] = {
      ...allPagesData[uri],
      id,
      templateName,
      uri,
      title,
      databaseId,
      status,
      nodeType,
      seoTitle,
      seoMetaDesc,
      ...parserWrapper(content, uri),
    };

    if (
      allPagesData[uri][CUSTOM_BLOCK_CLASSNAMES.CHILD_PAGES]
    ) {
      allPagesData[uri][
        CUSTOM_BLOCK_CLASSNAMES.CHILD_PAGES
      ].forEach(item => {
        allPagesData[item] = {
          ...allPagesData[item],
          parentUri: uri,
        };
      });
    }
  });
  return {
    allPagesData,
    categoryAndTagMap,
    searchDataArrayObject,
  };
};

const parserWrapper = (content, uri) => {
  const pageMetaDeta = {};
  const parserOptions = {
    replace: domNode => {
      if (
        domNode?.attribs?.["data-blocktype"] ===
        "custom-block"
      ) {
        const extractionFunc = extractionController(
          domNode.attribs.class
        );
        if (extractionFunc) {
          extractionFunc({
            uri,
            domNode,
            pageMetaDeta,
            pageType: domNode.attribs.class,
          });
        }
      }
    },
  };

  if (!content) {
    return {};
  }

  parse(content, parserOptions);
  return pageMetaDeta;
};

const extractionController = className => {
  switch (className) {
    case CUSTOM_BLOCK_CLASSNAMES.CHILD_PAGES:
    case CUSTOM_BLOCK_CLASSNAMES.FAQ_PAGES:
    case CUSTOM_BLOCK_CLASSNAMES.RELATED_QUERIES:
      return extractEmbeddedPages;
    case CUSTOM_BLOCK_CLASSNAMES.THUMBNAIL:
      return extractThumbnailUrl;
    case CUSTOM_BLOCK_CLASSNAMES.PAGE_DESCRIPTION:
      return extractPageDescription;
    case CUSTOM_BLOCK_CLASSNAMES.CONTACT_SUPPORT:
      return extractContactSupport;
    case CUSTOM_BLOCK_CLASSNAMES.FEEDBACK_SURVEY:
      return extractFeedbackSurvey;
    case CUSTOM_BLOCK_CLASSNAMES.CTA:
      return extractCTADetails;
    default:
      return null;
  }
};

const extractThumbnailUrl = ({
  uri,
  domNode,
  pageMetaDeta,
}) => {
  pageMetaDeta.thumbnailUrl = domNode?.children[1]?.children[2]?.children[0]?.attribs?.srcSet
    .split(",")?.[2]
    ?.split(" ")?.[0];
  if (!pageMetaDeta.thumbnailUrl) {
    console.log(
      "thumbnailUrl not provided correctly for",
      uri
    );
  }
};

const extractEmbeddedPages = ({
  uri,
  domNode,
  pageMetaDeta,
  pageType,
}) => {
  const pages = pageMetaDeta[pageType];
  const newPages = domNode?.children[1]?.children[1]?.children
    .filter(
      child =>
        child?.children?.[0]?.attribs?.href !== undefined
    )
    .map(child => child?.children?.[0]?.attribs?.href);
  if (pages && Array.isArray(pages)) {
    pageMetaDeta[pageType] = [...pages, ...newPages];
  } else {
    pageMetaDeta[pageType] = newPages;
  }
  if (!pageMetaDeta[pageType]) {
    console.log(
      `${pageType} not provided correctly for `,
      uri
    );
  }
};

const extractPageDescription = ({
  uri,
  domNode,
  pageMetaDeta,
}) => {
  pageMetaDeta.pageDescription =
    domNode?.children[1]?.children[0]?.data;

  if (!pageMetaDeta.pageDescription) {
    console.log(
      "Page Excerpt not provided correctly for",
      uri
    );
  }
};

const extractContactSupport = ({
  uri,
  domNode,
  pageMetaDeta,
}) => {
  pageMetaDeta.contactSupport =
    domNode?.children[1]?.children[0]?.data;

  if (!pageMetaDeta.contactSupport) {
    console.log(
      "Contact Support not provided correctly for",
      uri
    );
  }
};

const extractFeedbackSurvey = ({
  uri,
  domNode,
  pageMetaDeta,
}) => {
  pageMetaDeta.feedbackSurvey =
    domNode?.children[1]?.children[0]?.data;

  if (!pageMetaDeta.feedbackSurvey) {
    console.log(
      "Feedback Survey not provided correctly for",
      uri
    );
  }
};

const extractCTADetails = ({
  uri,
  domNode,
  pageMetaDeta,
}) => {
  if (!pageMetaDeta.ctaDetails) {
    pageMetaDeta.ctaDetails = null;
  }

  const contentClassIndex = domNode?.children?.findIndex(
    item => doesContainClass(item, "cta-section")
  );

  const ctaObject = createCtaObject(
    domNode?.children[contentClassIndex]
  );

  if (ctaObject) {
    pageMetaDeta.ctaDetails = ctaObject;
  } else {
    console.log(
      "ctaDetails not provided correctly for",
      uri
    );
  }
};

const doesContainClass = (item, className) =>
  item?.attribs?.class?.includes(className);

const createCtaObject = contentDomNode => {
  const ctaClassNames = {
    ctaTitle: "cta-title",
    ctaSubtitle: "cta-subtitle",
    ctaAppDeeplink: "cta-app-deeplink",
    ctaWebLink: "cta-web-link",
    ctaType: "cta-type",
  };
  const ctaObject = {};
  contentDomNode?.children?.forEach(item => {
    if (doesContainClass(item, ctaClassNames.ctaTitle)) {
      ctaObject.ctaTitle = extractChildsData(item);
    }
    if (doesContainClass(item, ctaClassNames.ctaSubtitle)) {
      ctaObject.ctaSubtitle = extractChildsData(item);
    }
    if (
      doesContainClass(item, ctaClassNames.ctaAppDeeplink)
    ) {
      ctaObject.ctaAppDeeplink = extractChildsData(item);
    }
    if (doesContainClass(item, ctaClassNames.ctaWebLink)) {
      ctaObject.ctaWebLink = extractChildsData(item);
    }
    if (doesContainClass(item, ctaClassNames.ctaType)) {
      ctaObject.ctaType = extractChildsData(item);
    }
  });

  return ctaObject;
};

const extractChildsData = (domNode, index = 0) =>
  domNode?.children?.[index]?.data?.trim();

module.exports = {
  createPagesData,
  extractionController,
  CUSTOM_BLOCK_CLASSNAMES,
};
